// extracted by mini-css-extract-plugin
export default {"chatInputContainer":"ChatInput_chatInputContainer__mfVva","chatInput":"ChatInput_chatInput__gbvHE","chatButton":"ChatInput_chatButton__yKRNb"};